import { ensureElement } from "../utils/utils";
import { Component } from "./base/Component";
export class Form extends Component {
    constructor(container, events) {
        super(container);
        this.container = container;
        this.events = events;
        this._submit = ensureElement('button[type=submit]', this.container);
        this._errors = ensureElement('.form__errors', this.container);
        this.container.addEventListener('input', (e) => {
            const target = e.target;
            const field = target.name;
            const value = target.value;
            this.onInputChange(field, value);
        });
        this.container.addEventListener('submit', (e) => {
            e.preventDefault();
            this.events.emit(`${this.container.name}:submit`);
        });
    }
    onInputChange(field, value) {
        this.events.emit('orderInput:change', {
            field,
            value
        });
    }
    set valid(value) {
        this._submit.disabled = !value;
    }
    set errors(value) {
        this.setText(this._errors, value);
    }
}
